<template>
    <!-- La pagina ha il solo scopo di aprire il form hubspot messo a disposizone da -->
    <!-- Welfarebit per la richiesta di convenzionamento di un fornitore da parte    -->
    <!-- degli utenti. -->
    <b-card class="mr-1 ml-1 mt-2">
      <b-row>
        <b-col class="text-center">
          <h4>Il form di richiesta si aprirà tra breve...</h4>
        </b-col>
      </b-row>
    </b-card>
</template>

<script>
export default {
  name: 'ConvRequestForm',
  data () {
    return {
      // Url del form di richiesta convenzione
      form_url : 'https://lp.welfarebit.it/it-it/lp_dipendenti_aziende_convenzioni_ondemand'
    }
  },
  /**
   * Non appena aperta, la pagina apre a sua volta il form di convenzionamento in un nuovo
   * tab e ci riporta quindi al menù principale.
   */
  created : function () {
    let new_window = window.open();
    new_window.location = this.form_url;
    // Usiamo replace, non ci serve di avere questa pagina nella history
    // di navigazione.
    this.$router.replace( { name : 'menu' } );
  }
}
</script>

<style scoped></style>